import { useEffect, useEffectEvent } from 'react';

import { Typography } from 'antd';

import PreviewProduct from '@/components/wizard/PreviewProduct';
import { useStepChangeBroadcaster } from '@/hooks/useStepChangeBroadcaster';
import { cn } from '@/lib/cn';
import useStepStore from '@/stores/steps';
import { type Step as StoreStep } from '@/stores/steps';

import Footer from './Footer';
import Information from './Information';
import Progress from './Progress';
import Steps from './Steps';

type StepsProps = {
  steps?: StoreStep[];
  children?: React.ReactNode;
};

const Wizard = ({ children, steps }: StepsProps) => {
  useStepChangeBroadcaster();

  const setSteps = useStepStore(({ setSteps }) => setSteps);
  const currentStepData = useStepStore(({ stepData }) => stepData);
  const init = useEffectEvent(setSteps);

  useEffect(() => {
    init(steps || []);
  }, [steps]);

  return (
    <section className='bg-surface-default flex h-full w-full transition-all'>
      <div className='relative flex h-full w-full flex-col transition-all'>{children}</div>

      <div
        className={cn(
          'dotted-bg min-w-70.4 hidden shrink-0 items-center justify-center p-4 transition-all lg:flex lg:flex-col xl:w-2/5',
          {
            'lg:invisible lg:w-0! lg:p-0': currentStepData?.hidePreviewContainer,
            '[&>article]:transform-[scale(0)]! [&>div]:transform-[scale(0)]!': currentStepData?.hidePreview
          }
        )}
      >
        <Typography className='text-content-disabled! dark:text-content-caption! mb-6! text-center! text-base! font-semibold!'>
          Veja como seu produto está ficando!
        </Typography>
        <PreviewProduct />
      </div>
    </section>
  );
};

Wizard.Steps = Steps;
Wizard.Progress = Progress;
Wizard.Footer = Footer;
Wizard.Information = Information;

export default Wizard;
